// extracted by mini-css-extract-plugin
export default {"page":"n4-z","cartModal":"o4-z","checkout":"p4-z","placeholder":"q4-z","account":"r4-z"};